import {Vue, Component, Prop, PropSync, Provide, ProvideReactive, Watch} from 'vue-property-decorator';
import DatePicker from "vue2-datepicker";
import { IndieLogin } from "@/app/services/indie-login";
import store from '../../../../store';

@Component<HeaderComponent>({
  components: ({
    DatePicker
  })
})
export default class HeaderComponent extends Vue {
  @Prop() private indieLogin!: IndieLogin;

  private accountDropdown: boolean = false;

  constructor() {
    super();
  }

  mounted() {
    return true;
  }

  created() {
    if(this.indieLogin.hasFailedLogin()){
      this.indieLogin.openLoginPopup();
      this.indieLogin.clearAuthenticationFailure();
    }
  }

  destroyed() {
    return true;
  }

  updated() {
    return true;
  }

  private get affiliateLogo(): string{
      if(store.state.affiliateViewData){
        return store.state.affiliateViewData.logo;
      }
      return '';
  }

  public get accountEditUrl(){
    return process.env.VUE_APP_ACCOUNT_URL_EDIT;
  }

  private toSavedTrips() {
    this.$router.push("/saved-trips");
  }
  private toggleAccountDropdown() {
    this.accountDropdown = !this.accountDropdown;
  }

  private hideAccountDropdown(delay?: number) {
    if (delay === undefined) {
      delay = 0;
    }
    setTimeout(() => this.accountDropdown = false, delay);
  }
}
